<p-button icon="fa fa-solid fa-gear" i18n-label="@@configure-fields-configure" label="Fields" (onClick)="fieldsPanel.toggle($event)"
          severity="secondary" class="ml-1" [badge]="allFieldsVisible ? '': ' '" badgeSeverity="warn">
</p-button>
<p-popover #fieldsPanel [dismissable]="true" appendTo="body">
  <span i18n="@@configure-fields-visible-fields">Visible fields:</span>
  <p-multiSelect [(ngModel)]="visibleColumnKeys" (onChange)="onChangeFields()"
                 [options]="columnSelectItems()" [style]="{minWidth: '200px', marginLeft: '10px'}"
                 i18n-selectedItemsLabel="@@common-n-items-selected" selectedItemsLabel="{0} columns selected"
                 i18n-placeholder="@@common-choose" placeholder="(choose)">
  </p-multiSelect>
</p-popover>
